import i18n from 'i18next';
import { initReactI18next } from 'react-i18next'; 
import en from './locales/en.json';
import ar from './locales/ar.json';
import Cookies from "js-cookie";

const savedLanguage = Cookies.get("selectedLanguage") || "en";
i18n.use(initReactI18next)
  .init({
    fallbackLng: savedLanguage,
    resources:{
        en:{
            translation: en
        },
        ar:{
            translation: ar
        }
    },
    // lng: 'ar',
    debug: true,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    
  });


export default i18n;